export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.21-0906.40",
  commitId: "69add01c86f53cb1070f607c4891b97a6d1a94f7",
  commitTime: "2026-08-21T09:06:40.000Z",
});
